import { render, staticRenderFns } from "./PhoneSettings.vue?vue&type=template&id=93976610"
import script from "./PhoneSettings.vue?vue&type=script&lang=js"
export * from "./PhoneSettings.vue?vue&type=script&lang=js"
import style0 from "./PhoneSettings.vue?vue&type=style&index=0&id=93976610&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports